module.exports = __webpack_public_path__ + "img/T6-A-rc_16.4f9c329b.png";